import { useQuery } from '@tanstack/react-query';
import { searchSkills, type SkillSearchResult } from '../api/skills';

export function useSkillsSearch(query: string) {
  const trimmed = query.trim();
  const enabled = trimmed.length >= 2;

  return useQuery<SkillSearchResult[], Error>({
    queryKey: ['skills', trimmed],
    queryFn: () => searchSkills(trimmed),
    enabled,
    staleTime: 1000 * 60 * 60,
  });
}
